export function getClientInlineDraft(vente) {
  return {
    label: vente.client_label ?? '',
    dolibarr_thirdparty_id: vente.dolibarr_thirdparty_id ?? null,
  };
}

export function getClientDraftLabel(draft) {
  if (draft && typeof draft === 'object') {
    return draft.label ?? '';
  }

  return draft ?? '';
}

export function clientInlineDraftEquals(draft, vente) {
  const label = String(getClientDraftLabel(draft)).trim();
  const originalLabel = String(vente.client_label ?? '').trim();
  const dolibarrId = (draft && typeof draft === 'object' && Number(draft.dolibarr_thirdparty_id) > 0)
    ? Number(draft.dolibarr_thirdparty_id)
    : null;
  const originalDolibarrId = Number(vente.dolibarr_thirdparty_id) > 0
    ? Number(vente.dolibarr_thirdparty_id)
    : null;

  return label === originalLabel && dolibarrId === originalDolibarrId;
}

export function buildClientInlinePayload(draft) {
  const label = String(getClientDraftLabel(draft)).trim();
  const dolibarrId = (draft && typeof draft === 'object' && Number(draft.dolibarr_thirdparty_id) > 0)
    ? Number(draft.dolibarr_thirdparty_id)
    : null;

  const payload = {
    client_label: label,
    dolibarr_thirdparty_id: dolibarrId,
  };

  if (dolibarrId === null) {
    payload.entreprise_locale_id = null;
  }

  return payload;
}

export function createClientDraftFromSelect(client) {
  const id = Number(client?.id ?? 0);

  return {
    label: client?.nom ?? '',
    dolibarr_thirdparty_id: id > 0 ? id : null,
  };
}

export function createClientDraftFromInput(value) {
  return {
    label: value ?? '',
    dolibarr_thirdparty_id: null,
  };
}
